import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { AppIcon } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';
import { Avatar, Box, Button, Typography } from '@mui/material';
var CONSULT_COACH_CARD_MAX_WIDTH = 286;
var CONSULT_COACH_CARD_MAX_HEIGHT = 367;
var PROFILE_IMAGE_SIZE_MAX = 82;
var MAX_VISIBLE_BADGES = 2;
var STRINGS = {
    coachLabel: appStrings.modules.nugget.coach,
    ctaLabel: appStrings.modules.deepDive.card.ctaLabel,
    moreBadges: function (count) { return "".concat(count, " more"); },
};
export var ConsultCoachCard = function (_a) {
    var _b, _c, _d, _e;
    var coach = _a.coach, _f = _a.variant, variant = _f === void 0 ? 'normal' : _f, onCardClick = _a.onCardClick, onCtaClick = _a.onCtaClick;
    var handleCtaClick = function (e) {
        e.stopPropagation();
        onCtaClick === null || onCtaClick === void 0 ? void 0 : onCtaClick(coach);
    };
    var fullName = "".concat(coach.first_name, " ").concat(coach.last_name);
    var hasCalendarLink = !!coach.consultation_calendar_url;
    var deepDiveNames = (_c = (_b = coach.deep_dives) === null || _b === void 0 ? void 0 : _b.map(function (dd) { return dd.name; })) !== null && _c !== void 0 ? _c : [];
    var visibleBadges = deepDiveNames.slice(0, MAX_VISIBLE_BADGES);
    var remainingBadgeCount = deepDiveNames.length - MAX_VISIBLE_BADGES;
    return (_jsx(Box, { sx: cardSx(variant), onClick: function () { return onCardClick === null || onCardClick === void 0 ? void 0 : onCardClick(coach); }, children: _jsxs(Box, { sx: contentSx, children: [_jsxs(Box, { sx: headerSx, children: [_jsx(Box, { sx: profileImageWrapSx, children: coach.profile_image_url ? (_jsx(Box, { component: "img", src: coach.profile_image_url, sx: profileImageSx })) : (_jsx(Box, { sx: profileImagePlaceholderSx })) }), _jsxs(Box, { sx: nameContainerSx, children: [_jsx(Typography, { variant: "text-lg-semibold", sx: nameSx, children: fullName }), coach.headline && (_jsx(Typography, { variant: "text-sm-regular", sx: headlineSx, children: coach.headline }))] })] }), _jsxs(Box, { sx: infoLinesSx, children: [coach.job_title && (_jsxs(Box, { sx: infoLineSx, children: [_jsx(AppIcon, { iconName: "Clock", diameter: "16px", color: "Gray/400" }), _jsx(Typography, { variant: "text-sm-regular", sx: infoTextSx, children: coach.job_title })] })), ((_d = coach.education) === null || _d === void 0 ? void 0 : _d[0]) && (_jsxs(Box, { sx: infoLineSx, children: [coach.education[0].logo_url ? (_jsx(Avatar, { src: coach.education[0].logo_url, sx: infoLogoSx })) : (_jsx(AppIcon, { iconName: "Bank", diameter: "16px", color: "Gray/400" })), _jsx(Typography, { variant: "text-sm-regular", sx: infoTextSx, children: coach.education[0].name })] })), ((_e = coach.employers) === null || _e === void 0 ? void 0 : _e[0]) && (_jsxs(Box, { sx: infoLineSx, children: [coach.employers[0].logo_url ? (_jsx(Avatar, { src: coach.employers[0].logo_url, sx: infoLogoSx })) : (_jsx(AppIcon, { iconName: "Building06", diameter: "16px", color: "Gray/400" })), _jsx(Typography, { variant: "text-sm-regular", sx: infoTextSx, children: coach.employers[0].name })] }))] }), _jsxs(Box, { sx: bottomSectionSx, children: [deepDiveNames.length > 0 && (_jsxs(Box, { sx: badgesContainerSx, children: [visibleBadges.map(function (badge) { return (_jsx(Box, { sx: categoryBadgeSx, children: _jsx(Typography, { variant: "text-xs-medium", children: badge }) }, badge)); }), remainingBadgeCount > 0 && (_jsxs(Box, { sx: moreBadgeSx, children: [_jsx(AppIcon, { iconName: "Plus", diameter: "12px", color: "Brand/500" }), _jsx(Typography, { variant: "text-xs-medium", children: STRINGS.moreBadges(remainingBadgeCount) })] }))] })), variant !== 'simple' && (_jsxs(Button, { id: "consult-coach-schedule-btn", hierarchy: "Primary", size: "lg", fullWidth: true, disabled: !hasCalendarLink, onClick: handleCtaClick, children: [_jsx(AppIcon, { iconName: "CalendarPlus01", diameter: "20px", color: "currentColor" }), _jsx(Typography, { variant: "text-sm-semibold", children: STRINGS.ctaLabel })] }))] })] }) }));
};
var cardSx = function (variant) {
    return function (_a) {
        var backrs = _a.backrs;
        return ({
            display: 'flex',
            flexDirection: 'column',
            borderRadius: backrs.radius['radius-4xl'],
            border: "1px solid ".concat(backrs.colors['Colors/Base/Black']),
            overflow: 'hidden',
            width: variant === 'normal' ? '100%' : 'unset',
            maxWidth: variant === 'normal' ? CONSULT_COACH_CARD_MAX_WIDTH : 'unset',
            minWidth: variant === 'normal' ? '268px' : 'unset',
            height: CONSULT_COACH_CARD_MAX_HEIGHT,
            backgroundColor: backrs.colors['Colors/Background/bg-primary'],
            cursor: 'pointer',
            userSelect: 'none',
            transition: 'all 0.3s ease-in-out',
            boxShadow: "0px 0px 0px 0px ".concat(backrs.colors['Colors/Base/Black']),
            '&:hover': {
                borderColor: backrs.colors['Colors/Foreground/fg-primary'],
                transform: 'translate(-2px, -2px)',
                boxShadow: backrs.shadows['shadow-lg'],
            },
            '&:active': {
                transform: 'none !important',
                boxShadow: 'none !important',
                transition: 'all 0s !important',
            },
        });
    };
};
var contentSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        gap: backrs.spacing['spacing-xl'],
        paddingX: backrs.spacing['spacing-xl'],
        paddingTop: backrs.spacing['spacing-xl'],
        paddingBottom: backrs.spacing['spacing-3xl'],
        width: '100%',
        flex: 1,
    });
};
var headerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        gap: backrs.spacing['spacing-xl'],
        alignItems: 'flex-start',
    });
};
var profileImageWrapSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        position: 'relative',
        width: PROFILE_IMAGE_SIZE_MAX,
        height: PROFILE_IMAGE_SIZE_MAX,
        minWidth: PROFILE_IMAGE_SIZE_MAX,
        borderRadius: backrs.radius['radius-xl'],
        border: "1px solid ".concat(backrs.colors['Colors/Base/Black']),
        overflow: 'hidden',
    });
};
var profileImageSx = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
};
var profileImagePlaceholderSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        width: '100%',
        height: '100%',
        backgroundColor: backrs.colors['Gray/200'],
    });
};
var nameContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        gap: backrs.spacing['spacing-xl'],
        flex: 1,
        minWidth: 0,
    });
};
var nameSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        color: backrs.colors['Gray/900'],
        wordBreak: 'break-word',
    });
};
var headlineSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        color: backrs.colors['Gray/600'],
    });
};
var infoLinesSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        gap: backrs.spacing['spacing-sm'],
    });
};
var infoLineSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        alignItems: 'center',
        gap: backrs.spacing['spacing-xs'],
    });
};
var infoLogoSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        width: '16px',
        height: '16px',
        borderRadius: backrs.radius['radius-md'],
    });
};
var infoTextSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        color: backrs.colors['Gray/600'],
    });
};
var badgesContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexWrap: 'wrap',
        gap: backrs.spacing['spacing-md'],
    });
};
var categoryBadgeSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        backgroundColor: backrs.colors['Brand/50'],
        border: "1px solid ".concat(backrs.colors['Brand/200']),
        color: backrs.colors['Brand/700'],
        borderRadius: '16px',
        paddingX: backrs.spacing['spacing-md'],
        paddingY: backrs.spacing['spacing-xxs'],
    });
};
var moreBadgeSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        alignItems: 'center',
        gap: backrs.spacing['spacing-xs'],
        backgroundColor: backrs.colors['Brand/50'],
        border: "1px solid ".concat(backrs.colors['Brand/200']),
        color: backrs.colors['Brand/700'],
        borderRadius: '16px',
        paddingLeft: backrs.spacing['spacing-sm'],
        paddingRight: backrs.spacing['spacing-md'],
        paddingY: backrs.spacing['spacing-xxs'],
    });
};
var bottomSectionSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        gap: backrs.spacing['spacing-xl'],
        marginTop: 'auto',
    });
};
